import RecentlyFundedSection from './RecentlyFundedSection';

export default RecentlyFundedSection;
